// src/lib/autoRaceFromSchedule.js

// ---- Basic parsing ----
export function toInt(v) {
    const n = parseInt(String(v ?? "").trim(), 10);
    return Number.isFinite(n) ? n : null;
}

export function parseDEDateTime(str) {
    // erwartet "dd.mm.yyyy hh:mm"
    const s = String(str ?? "").trim();
    const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})$/);
    if (!m) return null;

    const dd = Number(m[1]);
    const mm = Number(m[2]);
    const yyyy = Number(m[3]);
    const HH = Number(m[4]);
    const MM = Number(m[5]);

    const dt = new Date(yyyy, mm - 1, dd, HH, MM, 0, 0); // lokale TZ (Browser)
    return Number.isNaN(dt.getTime()) ? null : dt;
}

// ---- Sheet response normalization ----
// akzeptiert sowohl {values:[[]]} als auch {header:[], rows:[{..}]}
export function normalizeSheetMatrix(res) {
    if (Array.isArray(res?.values) && res.values.length > 0) {
        return res.values;
    }
    if (Array.isArray(res?.header) && Array.isArray(res?.rows)) {
        const headers = res.header;
        const bodyRows = (res.rows || []).map((rowObj) =>
            headers.map((h) => rowObj?.[h] ?? "")
        );
        return [headers, ...bodyRows];
    }
    return [];
}

export function stripScheduleHeader(matrix) {
    if (!Array.isArray(matrix) || !matrix.length) return [];
    return toInt(matrix[0]?.[0]) === null ? matrix.slice(1) : matrix;
}

export function computeActiveRaceFromSchedule(scheduleMatrix, mode /* "briefing" | "results" */) {
    // Schedule: A=#, B=Strecke, C=BriefingFrom, D=ResultsFrom
    const now = new Date();
    let best = null;

    for (const row of scheduleMatrix) {
        const id = toInt(row?.[0]);
        if (!id) continue;

        const dtStr = mode === "briefing" ? row?.[2] : row?.[3];
        const dt = parseDEDateTime(dtStr);
        if (!dt) continue;

        if (now >= dt) {
            if (best === null || id > best) best = id;
        }
    }
    return best ?? 1;
}

/**
 * Convenience: lädt Schedule (A1:D), berechnet Auto-Race und gibt Zahl zurück.
 * mode:
 *  - "briefing" -> nimmt Spalte C
 *  - "results"  -> nimmt Spalte D
 */
export async function getAutoRaceFromSchedule(fetchSheetViaProxy, scheduleRange, mode) {
    const res = await fetchSheetViaProxy({ range: scheduleRange });
    const m = normalizeSheetMatrix(res);
    const rows = stripScheduleHeader(m);
    return computeActiveRaceFromSchedule(rows, mode);
}
